import Vue from 'vue'
import VueSanitize from 'vue-sanitize'

Vue.use(VueSanitize, {
  allowedTags: [
    'a', 'b', 'i', 'u', 'ul', 'li', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br', 'p',
  ],
  allowedAttributes: {
    // eslint-disable-next-line
    'a': ['href', 'target', 'class', 'style', 'title'],
    // eslint-disable-next-line
    'b': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'i': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'u': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'p': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'ul': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'li': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'ol': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h1': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h2': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h3': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h4': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h5': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'h6': ['class', 'style', 'title'],
    // eslint-disable-next-line
    'br': ['class', 'style', 'title'],
  },
})
